import React from "react";
import BannerImage from "../../../assets/images/aboutusbg.png";
import Banner from "../banner";

const BRIGHT_AIRWAYS_URL = "https://www.brightairways.in/";
const INSTAGRAM_URL = "https://www.instagram.com/brightairways/";

const Main = () => {
  return (
    <>
      <Banner
        img={BannerImage}
        title="How to Find Verified Aviation Jobs in India: 2025 Guide"
      />
      <div className="container mt-4 mb-5">
        <article className="blog-article">
          <header className="mb-4">
            <h3 className="fw-bold">Introduction</h3>
            <p>
              The aviation industry in India is booming. With the rise in
              domestic and international air traffic, the demand for qualified
              professionals in roles such as cabin crew, ground staff, airport
              operations, air ticketing, and customer service is growing fast.
            </p>
            <p>
              But there&apos;s a huge problem—fake job offers.
            </p>
            <p>
              In this blog, we&apos;ll guide you step-by-step on how to find
              verified aviation jobs in India and how trusted platforms like{" "}
              <a
                href={BRIGHT_AIRWAYS_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                Bright Airways
              </a>{" "}
              are making job placements more secure and transparent for aspiring
              candidates.
            </p>
          </header>

          <section className="mb-4">
            <h3 className="fw-semibold">
              1. Understand the Roles in Aviation
            </h3>
            <p>
              Before applying, it&apos;s important to know the type of roles
              available:
            </p>
            <ul>
              <li>Cabin Crew / Air Hostess</li>
              <li>Ground Staff / Customer Support</li>
              <li>Airport Operations Executive</li>
              <li>Air Ticketing Agent</li>
              <li>Baggage Handling Staff</li>
              <li>Security and Safety Officer</li>
              <li>Flight Dispatcher</li>
            </ul>
            <p>
              Each job requires different skills, certifications, and sometimes
              a specific grooming standard or language proficiency.
            </p>
          </section>

          <section className="mb-4">
            <h3 className="fw-semibold">
              2. Build the Right Skills &amp; Qualifications
            </h3>
            <ul>
              <li>Completed aviation-related certification or diploma courses</li>
              <li>Good communication and interpersonal skills</li>
              <li>
                Basic computer and ticketing system knowledge (like Galileo,
                Amadeus)
              </li>
              <li>Customer-handling experience (for ground staff roles)</li>
              <li>Professional grooming and confidence (for cabin crew)</li>
            </ul>
            <div className="blog-tip">
              💡 Bright Airways offers online aviation courses with placement
              support, helping students develop job-ready skills from home.
            </div>
          </section>

          <section className="mb-4">
            <h3 className="fw-semibold">
              3. How to Identify Verified Job Offers
            </h3>
            <p>
              There are hundreds of fake aviation job posts on WhatsApp,
              Telegram, and even social media. Here&apos;s how to spot the real
              ones:
            </p>

            <h5 className="fw-semibold mt-3">🔐 Signs of a Verified Job:</h5>
            <ul>
              <li>Comes from a registered aviation institute or airline</li>
              <li>
                Doesn&apos;t ask for advance payment or &quot;registration
                fees&quot; without proper documentation
              </li>
              <li>Provides company name, interview, and contact person</li>
              <li>
                Has a company email (not Gmail/Yahoo) and a verified website
              </li>
            </ul>

            <h5 className="fw-semibold mt-3">🚨 Red Flags (FAKE JOB ALERT):</h5>
            <ul>
              <li>&quot;Pay ₹5000 for interview slot&quot;</li>
              <li>&quot;Limited seats, register now via UPI&quot;</li>
              <li>&quot;Work from home airline jobs&quot; (usually fake)</li>
              <li>Fake airline logos on offer letters</li>
            </ul>
          </section>

          <section className="mb-4">
            <h3 className="fw-semibold">
              4. Use Trusted Job Platforms &amp; Training Institutes
            </h3>
            <p>Top Platforms to Find Aviation Jobs in India:</p>
            <ul>
              <li>
                <a
                  href={BRIGHT_AIRWAYS_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  brightairways.in
                </a>{" "}
                (with placement after training)
              </li>
              <li>Indeed</li>
              <li>AviationCV.com</li>
              <li>Monster India</li>
              <li>Airline Career Pages (IndiGo, Vistara, Air India)</li>
            </ul>
            <div className="blog-tip">
              💡 Tip: Do not just rely on job portals. Training + Placement
              support gives you the upper hand. Institutes like Bright Airways
              not only train you but also connect you directly with verified
              employers in the industry.
            </div>
          </section>

          <section className="mb-4">
            <h3 className="fw-semibold">
              5. What Makes Bright Airways a Reliable Source?
            </h3>
            <ul>
              <li>100% Online aviation training with placement support</li>
              <li>Legal business registration + verified website</li>
              <li>No hidden fees or fake job guarantees</li>
              <li>Partnered with real placement consultancies in aviation</li>
              <li>Positive student reviews + growing social presence</li>
            </ul>
          </section>

          <section className="mb-4">
            <h3 className="fw-semibold">
              6. Final Steps to Get a Real Aviation Job in 2025
            </h3>
            <ul>
              <li>✔️ Enroll in a trusted aviation course</li>
              <li>✔️ Polish your communication and grooming</li>
              <li>✔️ Create a professional resume with a photo</li>
              <li>✔️ Apply only via verified websites or job portals</li>
              <li>✔️ Attend walk-in interviews only after verification</li>
              <li>
                ✔️ Follow platforms like Bright Airways for legit openings
              </li>
            </ul>
          </section>

          <footer className="mt-4">
            <h3 className="fw-bold">
              Conclusion: Start Your Aviation Career with Confidence
            </h3>
            <p>
              The aviation industry has huge opportunities—but only if you take
              the right path. With platforms like Bright Airways, you get not
              only training but also genuine placement support, cutting out
              scams and fake agents.
            </p>
            <p>
              📩 Want to get started? Visit{" "}
              <a
                href={BRIGHT_AIRWAYS_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                www.brightairways.in
              </a>{" "}
              or message us on Instagram{" "}
              <a
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                @brightairways
              </a>{" "}
              for instant admission &amp; job updates.
            </p>

            <div className="blog-cta">
              <h3>Ready to Find Verified Aviation Jobs?</h3>
              <p>
                Get expert training, career guidance, and placement support with
                Bright Airways.
              </p>
              <a
                href={BRIGHT_AIRWAYS_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="blog-cta-btn"
              >
                Visit Bright Airways
              </a>
            </div>
          </footer>
        </article>
      </div>
    </>
  );
};

export default Main;
